import { isIdEqual } from 'modules/enumerations/enumerationHelpers';

/* eslint-disable array-callback-return */
export const checkDirty = (originalVals, newVals) => {
  let dirty = false;
  Object.keys(originalVals).map(fieldName => {
    // Checks the datetime cases for equivalence which have inconsistent format
    if (
      typeof originalVals[fieldName] === 'string' &&
      typeof newVals[fieldName] === 'string' &&
      originalVals[fieldName].includes('T00:00:00') &&
      !newVals[fieldName].includes('T00:00:00')
    ) {
      if (originalVals[fieldName] !== `${newVals[fieldName]}T00:00:00`) dirty = true;
    }
    // Checks the primary case where new and old values are different (ignores case where one is undefined and one is empty string)
    else if (
      originalVals[fieldName] !== newVals[fieldName] &&
      !(!originalVals[fieldName] && newVals[fieldName]?.length === 0) &&
      fieldName !== 'authorizationId'
    ) {
      dirty = true;
    }
  });
  return dirty;
};

// for Destination Services - set status types based on what service type is
export const setStatusTypes = (serviceType, status) => {
  let statusTypes = [];

  if (serviceType === 'Renter') {
    if (status === 'Canceled') {
      statusTypes = ['Initiated', 'Active Rental Search', 'Rental Secured', 'Canceled'];
    } else {
      statusTypes = ['Initiated', 'Active Rental Search', 'Rental Secured'];
    }
    return statusTypes;
  } else if (serviceType === 'Buyer') {
    if (status === 'Canceled') {
      statusTypes = ['Initiated', 'Agent Vetting', 'Active Homefinding', 'Under Contract', 'Canceled'];
    } else {
      statusTypes = ['Initiated', 'Agent Vetting', 'Active Homefinding', 'Under Contract', 'Closed'];
    }
    return statusTypes;
  } else {
    return ['Initiated'];
  }
};

// for candidate services - automatically calculate trip duration
export const calculateTripDuration = (startDay, endDay, tripDuration) => {
  if (tripDuration) {
    return tripDuration;
  } else {
    const newStartDate = new Date(startDay).getTime();
    const newEndDate = new Date(endDay).getTime();

    let msDay = 24 * 60 * 60 * 1000; // milliseconds per day
    return Math.floor((newEndDate - newStartDate) / msDay);
  }
};

export const formatTripAddress = (address, provinces = [], countries = []) => {
  if (!address) return '';

  const province = provinces.find(option => option.id === address.provinceId)?.title;
  const country = countries.find(option => option.id === address.countryId)?.title;

  const addressParts = [
    address.addressLine1,
    address.city,
    province,
    address.zipcode,
    country
  ];

  return addressParts.filter(value => value != null && value !== '').join(', ');
};

export const formatTripLocation = (address, provinces = [], countries = []) => {
  if (!address) return '';

  const province = provinces.find(option => option.id === address.provinceId)?.title;
  const country = countries.find(option => option.id === address.countryId)?.title;

  return [address.city, province, country].filter(value => value != null && value !== '').join(', ');
};

const CLIENT_PREFERRED_RELATIONSHIP_ID = '8C64C4E3-7A57-4E6A-9B7D-0E2A8A5A9B31';
const CLIENT_REQUIRED_RELATIONSHIP_ID = '2F9A6B11-3A0E-4D33-8B6C-7C0F7A6A2D8E';
const CLIENT_DO_NOT_USE_RELATIONSHIP_ID = 'D0D3B8C6-8E71-4A9D-9B1A-4D2E6B7C1F90';

// Builds the full vendor list ordered client required > client preferred > unranked, dropping "do not use".
export const CreateVendorRelationshipList = (vendors, vendorRelationships) => {
  if (!vendors || !Array.isArray(vendors)) {
    return [];
  }

  const relationships = Array.isArray(vendorRelationships) ? vendorRelationships : [];

  const preferred = [];
  const required = [];
  const none = [];

  vendors.forEach(vendor => {
    const vendorRelationship = relationships.find(relationship => relationship.vendorId === vendor.vendorId);
    const companyNameDisplay = vendorRelationship?.companyName ?? vendor.companyName ?? '';
    const merged = { ...vendor, ...vendorRelationship, companyNameDisplay };

    if (isIdEqual(vendorRelationship?.relationshipId, CLIENT_PREFERRED_RELATIONSHIP_ID)) {
      preferred.push({
        ...merged,
        companyName: `${companyNameDisplay} (Client Preferred)`,
        isPreferred: true,
        isRequired: false,
        isDoNotUse: false
      });
    } else if (isIdEqual(vendorRelationship?.relationshipId, CLIENT_REQUIRED_RELATIONSHIP_ID)) {
      required.push({
        ...merged,
        companyName: `${companyNameDisplay} (Client Required)`,
        isPreferred: false,
        isRequired: true,
        isDoNotUse: false
      });
    } else if (!isIdEqual(vendorRelationship?.relationshipId, CLIENT_DO_NOT_USE_RELATIONSHIP_ID)) {
      none.push({
        ...merged,
        companyName: companyNameDisplay,
        isPreferred: false,
        isRequired: false,
        isDoNotUse: false
      });
    }
  });

  return [...required, ...preferred, ...none];
};
